import { GET_TRANSACTIONS_OTP_PAYMENT, GET_OTP_TAXES, PAY_SERVICE } from './../constants';
import { handleActions } from "redux-actions"

export const otpCodes  = handleActions(
  { 
    [ GET_TRANSACTIONS_OTP_PAYMENT ]: (state, action) => action.payload,
    [ GET_OTP_TAXES ]: (state, action) => action.payload,
    [ PAY_SERVICE ]: (state, action) => action.payload,
    // [ GET_TRANSACTIONS_COMPARE_OTP_PAYMENT ]: (state, action) => action.payload,
  }, {}
)